export class PathHelper {
    misc: MiscPathHelper = new MiscPathHelper();
    file: FilePathHelper = new FilePathHelper();
    ticket: TicketPathHelper = new TicketPathHelper();
    recipient: RecipientPathHelper = new RecipientPathHelper();
    recipientlist: RecipientlistPathHelper = new RecipientlistPathHelper();
    user: UserPathHelper = new UserPathHelper();
    guest: GuestPathHelper = new GuestPathHelper();
    config: ConfigPathHelper = new ConfigPathHelper();
}

class GuestPathHelper {
    getCheckAuthMailPath(){
        return `guest/CheckForAuthMail`;
    }
    getTicketFileInfoPath(guid:string){
        return `guest/GetTicketInfo/${guid}`;
    }
    getStaticTicketFileInfoPath(guid:string){
        return `guest/GetStaticTicketInfo/${guid}`;
    }
    getCheckOtpPath(){
        return `guest/CheckForOTP`;
    }
    getCheckPwdPath(){
        return `guest/GetStaticTicketToken`;
    }
    getInitializeFilePath(){
        return `guest/InitializeFileAsync`;
    }
    getAbortUploadPath(uploadGuid:string){
        return `guest/AbortUploadAsync/${uploadGuid}`;
    }
    getUploadBlockPath(uploadGuid:string, blockIndex:number){
        return `guest/UploadBlockAsync/${uploadGuid}/blockIndex/${blockIndex}`;
    }
    getMissingBlocksPath(uploadGuid:string){
        return `guest/MissingBlocksAsync/${uploadGuid}`;
    }
    getCompleteUploadPath(uploadGuid:string){
        return `guest/CompleteUploadAsync/${uploadGuid}`;
    }
    getDownloadFilePath(ticketGuid:string){
        return `guest/GetFileDownload/${ticketGuid}`;
    }
    getTicketTypePath(ticketGuid:string){
        return `guest/GetTicketType/${ticketGuid}`;
    }
    getStaticDownloadFilePath(ticketGuid:string){
        return `guest/GetStaticFileDownload/${ticketGuid}`;
    }
}

class UserPathHelper {
    getByMailPath(){
        return `v2/user/GetByEmail`;
    }
    getUpdateUserConfigPath(){
        return `v2/user/UpdateConfig`;
    }
}

class RecipientPathHelper {
    getRecipientForUserPath(){
        return `v2/recipient/GetForUser`;
    }
    getByPath(){
        return `v2/recipient/GetBy`;
    }
    getUpdateRecipientPath(){
        return `v2/recipient/Update`;
    }
    getCreateRecipientPath(){
        return `v2/recipient/Create`;
    }
    getDeleteRecipientPath(){
        return `v2/recipient/Delete`;
    }
    getListAssociationsPath(){
        return `v2/recipient/GetListAssociations`;
    }
}

class RecipientlistPathHelper{
    getRecipientlistForUserPath(){
        return `v2/recipientlist/GetForUser`;
    }
    getByIdPath(){
        return `v2/recipientlist/GetById`;
    }
    getByPath(){
        return `v2/recipientlist/GetBy`;
    }
    getUpdateRecipientlistPath(){
        return `v2/recipientlist/Update`;
    }
    getCreateRecipientlistPath(){
        return `v2/recipientlist/Create`;
    }
    getDeleteRecipientlistPath(){
        return `v2/recipientlist/Delete`;
    }
    getRecipientAssociationsPath(){
        return `v2/recipientlist/GetRecipientAssociations`;
    }
    getUpdateRecipientAssociationsPath(){
        return `v2/recipientlist/UpdateRecipientAssociations`;
    }
}

class MiscPathHelper {
    getStartupConfigPath(){
        return `misc/startup`;
    }
}

class FilePathHelper {
    getFilesForUserPath(){
        return `v2/file/GetForUser`;
    }
    getByPath(){
        return `v2/file/GetBy`;
    }
    getUpdateFilePath(){
        return `v2/file/Update`;
    }
    getDeleteFilePath(){
        return `v2/file/Delete`;
    }
    getResetDeletionDatePath(){
        return `v2/file/ResetDeletionDate`;
    }
    getInitializeUploadPath(){
        return `v2/file/InitializeUpload`;
    }
    getDownloadFileByMailPath(fileGuid:string){
        return `v2/file/GetFileFromMailDownload/${fileGuid}`;
    }
    getDownloadFilePath(){
        return `v2/file/FileDownloadByDownloadToken`;
    }
    getUploadBlockPath(fileGuid:string, blockIndex:number){
        return `v2/file/UploadBlock/${fileGuid}/blockIndex/${blockIndex}`;
    }
    getMissingBlocksPath(fileGuid:string){
        return `v2/file/MissingBlocks/${fileGuid}`;
    }
    getAbortUploadPath(fileGuid:string){
        return `v2/file/AbortUpload/${fileGuid}`;
    }
    getCompleteUploadPath(fileGuid:string){
        return `v2/file/CompleteUpload/${fileGuid}`;
    }
}

class ConfigPathHelper {
    getConfigurationPath(){
        return `v2/serviceconfig/GetConfig`;
    }
    getUpdateConfigurationPath(){
        return `v2/serviceconfig/UpdateConfig`;
    }
}

class TicketPathHelper {
    getTicketsPath(){
        return `v2/ticket/GetForUser`;
    }
    getByPath(){
        return `v2/ticket/GetBy`;
    }
    getUpdateTicketPath(){
        return `v2/ticket/Update`;
    }
    getDeleteTicketPath(){
        return `v2/ticket/Delete`;
    }
    getGenerateTicketsPath(){
        return `v2/ticket/Generate`;
    }
    getResendTicketPath(){
        return `v2/ticket/ResendMail`;
    }
    getResendPasswordMailPath(){
        return `v2/ticket/ResendStaticPassword`;
    }
    getCreateStaticTicketPath(){
        return `v2/ticket/CreateStatic`;
    }
}
